(function () {
  'use strict';

  function pauseAll(root) {
    root.querySelectorAll('.swiper-slide.swiper__video video').forEach(function (video) {
      if (!video.paused) video.pause();
    });
  }

  function muteVideo(video) {
    video._vcUserUnmuted = false;
    video.muted = true;
    var slide = video.closest('.swiper-slide');
    var button = slide && slide.querySelector('.video__toggle-sound-button');
    if (button) {
      button.classList.add('mute');
      button.classList.remove('unmute');
      button.setAttribute('aria-pressed', 'false');
    }
  }

  function toggleSound(button) {
    var slide = button.closest('.swiper-slide');
    var video = slide && slide.querySelector('video');
    if (!video) return;

    if (video.muted) {
      video._vcUserUnmuted = true;
      video.muted = false;
      button.classList.remove('mute');
      button.classList.add('unmute');
      button.setAttribute('aria-pressed', 'true');
    } else {
      muteVideo(video);
    }
  }

  function prepareVideo(video) {
    // Expando (não data-*) — clones do Swiper copiam data-* mas nascem sem buffer.
    if (video._vcPrepared) return;
    video._vcPrepared = true;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    video.addEventListener('loadeddata', function () {
      if (video.hasAttribute('poster')) {
        video.removeAttribute('poster');
      }
      try {
        if (video.duration && !isNaN(video.duration) && video.currentTime < 0.2) {
          video.currentTime = Math.min(0.6, Math.max(0.2, video.duration * 0.04));
        }
      } catch (e) {}
    });

    video.addEventListener('playing', function () {
      if (video.hasAttribute('poster')) {
        video.removeAttribute('poster');
      }
    });
  }

  function syncVideos(root) {
    // Só o slide ATIVO reproduz e baixa o vídeo; os peeks ficam no poster.
    var sectionVisible = root._vcInViewport !== false;
    var pageVisible = document.visibilityState === 'visible';

    root.querySelectorAll('.swiper-slide.swiper__video video').forEach(function (video) {
      prepareVideo(video);

      var slide = video.closest('.swiper-slide');
      if (!slide) return;

      var isActive = slide.classList.contains('swiper-slide-active');

      if (isActive && sectionVisible && pageVisible) {
        if (video.preload !== 'auto') video.preload = 'auto';

        // load() no máximo uma vez por elemento (expando, não data-*).
        if (video.readyState < 2 && !video._vcDidLoad) {
          video._vcDidLoad = true;
          try {
            video.load();
          } catch (e) {}
        }

        if (video.paused) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
      } else {
        // Não ativo ou fora de vista: pausar e re-silenciar
        // (autoplay com som é bloqueado pelo browser).
        if (!video.paused) video.pause();
        if (video._vcUserUnmuted || !video.muted) muteVideo(video);
      }
    });
  }

  function initCarousel(root) {
    if (root._vcInit) return;
    root._vcInit = true;

    // Assumir fora de viewport até o IntersectionObserver confirmar.
    // Sem isto, os warm-ups do init marcavam o slide ativo com preload=auto
    // + load() antes do IO disparar → 4MB de vídeo baixados abaixo do fold
    // (e preload=auto não se cancela com pause()).
    root._vcInViewport = false;

    var swiper = new Swiper(root, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      loop: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: root.querySelector('.video-carousel-next'),
        prevEl: root.querySelector('.video-carousel-prev'),
      },
      on: {
        init: function () {
          syncVideos(root);
        },
        loopFix: function () {
          syncVideos(root);
        },
        slideChange: function () {
          syncVideos(root);
        },
        slideChangeTransitionEnd: function () {
          syncVideos(root);
        },
        resize: function () {
          syncVideos(root);
        },
        touchEnd: function () {
          syncVideos(root);
        },
        click: function (sw, event) {
          if (event && event.target && event.target.closest('.video__toggle-sound-button')) return;
          if (!this.clickedSlide || this.clickedSlide.classList.contains('swiper-slide-active')) return;
          var info = this.clickedSlide.getAttribute('data-info');
          if (info != null) this.slideToLoop(info);
        },
      },
    });

    // Warm-up: o loop do Swiper cria clones depois do init.
    requestAnimationFrame(function () {
      syncVideos(root);
      requestAnimationFrame(function () {
        syncVideos(root);
      });
    });
    setTimeout(function () {
      syncVideos(root);
    }, 200);
    setTimeout(function () {
      syncVideos(root);
    }, 700);

    // Pausa/retoma pelos limites da viewport (substitui o setInterval de 1s).
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          root._vcInViewport = entry.isIntersecting;
          if (entry.isIntersecting) {
            syncVideos(root);
          } else {
            pauseAll(root);
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(root);

    root.addEventListener('click', function (event) {
      var button = event.target.closest('.video__toggle-sound-button');
      if (button) toggleSound(button);
    });

    root._videoCarouselSwiper = swiper;
    root._vcObserver = observer;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.video-carousel__swiper').forEach(initCarousel);
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.video-carousel__swiper').forEach(function (root) {
      if (root._vcObserver) root._vcObserver.disconnect();
      if (root._videoCarouselSwiper) root._videoCarouselSwiper.destroy(true, false);
    });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('.video-carousel__swiper').forEach(function (root) {
      if (root._vcInit) syncVideos(root);
    });
  });
})();
